(function(){
'use strict';
  angular.module('irricrops')
  .controller("cuartelDetalleCtrl", [
    "$scope", "CONSTANTES", "Config","$q","cuartel_id", "isDialog",
    'CuartelRes', 'CuartelFac','temporadaFac','$rootScope', 'global',
    'HcConvert', 'MultiChart','$filter','$timeout', '$mdDialog',
    function($scope, CONSTANTES, Config, $q, cuartel_id, isDialog,
      CuartelRes, CuartelFac, temporadaFac,$rootScope, global,
      HcConvert, MultiChart, $filter, $timeout, $mdDialog){

        var vm                     = this;
        vm.loadingTemporada        = false;
        vm.temporadaSelectedWindow = null;
        vm.temporadaSelected       = null;
        vm.temporadas              = [];
        vm.comparando              = false;
        vm.config                  = Config;
        vm.CONSTANTES              = CONSTANTES;
        vm.cuartel                 = null; //cuartel.data;
        vm.estados                 = []; //angular.copy(vm.cuartel.estados);
        vm.showedWindowEstado      = false;
        vm.estadoNuevo             = null;
        vm.vinedo_id               = null; //vm.cuartel.vinedo_id;
        vm.riegoNormal             = 0;
        vm.reposicion              = 0;
        vm.exedente                = true;
        vm.riegoNormalMM           = 0; //vm.riegoNormal * vm.cuartel.precipitacion_sistema;
        vm.menuComentario          = false;
        vm.menuEditarComentario    = false;
        vm.comparisonType          = "temporada";
        vm.switchComentario        = true;  //true para comentarios Flag
        vm.comentarioTexto         = "";
        vm.errorComentario         = "";
        vm.errorEditarComentario   = "";
        vm.dataChart               = {};
        vm.isIncluded              = $scope.included || false;

        vm.datosSelect =  [
          {id : 0, label  : 'temporada', msg   : 'Temporada'},
          {id : 1, label  : 'mes'      , msg   : 'Último Mes'},
          {id : 2, label  : 'fechas'   , msg   : 'Seleccion de fechas'},
          {id : 3, label  : 'simulador', msg   : 'Simulador'}
        ];

        var hideBackdropCallback   = null;
        var popoverEstadosDirty = false;

        var saturacion = 0;
        var ur         = 0;
        var cc         = 0;
        var pmp        = 0;

      vm.mobileChart = false;
      if(global.responsiveIs("xs")){
        vm.mobileChart = true;
      }





      var init = function(){
        //define fecha en los estados fenologicos
        angular.forEach(vm.estados, function(estado) {
          if(estado.dateInicio === undefined){
            estado.dateInicio = moment.unix(estado.inicio).toDate();
            if (estado.final !== null) {
              estado.dateTermino = moment.unix(estado.final).toDate();
            }else{
              estado.dateTermino = null;
            }
          }
        });

        var promTemp    = temporadaFac.getTemporadas();
        var promCuartel = CuartelRes.getData({
          sector_riego_id: cuartel_id,
          fecha: null
        }).$promise;
        $q.all([promTemp, promCuartel]).then(function(res){
          vm.cuartel       = res[1].data;
          vm.estados       = angular.copy(vm.cuartel.estados);
          vm.vinedo_id     = vm.cuartel.vinedo_id;
          vm.riegoNormalMM = vm.riegoNormal * vm.cuartel.precipitacion_sistema;


          if(!isDialog){
            var variedades   = "";
            var calidades    = "";
            angular.forEach(vm.cuartel.variedades, function(variedad){
              variedades += variedad.nombre + " ";
              calidades += variedad.calidades[0].nombre + " ";
            });

            global.title = vm.cuartel.nombre;//+" ("+variedades+" / "+calidades+")";
            global.titleData = [{
              name : 'Variedades',
              data : variedades
            },
              {
                name : 'Calidades',
                data : calidades
              },{
                name : 'Viñedo',
                data : vm.cuartel.vinedo_nombre
              }];
            Config.vinedo = vm.cuartel.configuracion;
            angular.forEach(Config.vinedo, function(item, index){
              if (item == '1' || item === 1) {
                Config.vinedo[index] = true;
              }
              if (item == '0' || item === 0) {
                Config.vinedo[index] = false;
              }
            });
          }



          vm.temporadas              = res[0].data.data;
          vm.temporadaSelected       = temporadaFac.getActiva();
          vm.temporadaSelectedWindow = temporadaFac.getActiva();
          vm.temporadaComparada      = temporadaFac.getAnterior(vm.temporadaSelected);
          if(vm.mobileChart){
            vm.lapsoTiempoChange(vm.datosSelect[1]);
          }else{
            vm.lapsoTiempoChange(vm.datosSelect[0]);
          }
        });
      }
      init();







          vm.comparar = function(b) {
            if (angular.isUndefined(b)) {
              b = true;
            }
            vm.comparando = b;
            if (vm.comparando) {
              vm.initMultiChartTemporadaComparada();
            }
          };

          vm.changeTemporada = function() {
            vm.loadingTemporada = true;
            vm.initMultiChartTemporada();
          };


          vm.changeTemporadaComparada = function() {
            vm.loadingTemporadaComparada = true;
            vm.initMultiChartTemporadaComparada();
          };

        vm.lapsoTiempoChange = function(lapso){
          vm.lapsoTiempo = lapso;
          vm.comparar(false);
          switch(lapso.label){
            case 'mes':
              vm.initMultiChartMes();
              break;
            case 'temporada':
              vm.initMultiChartTemporada();
              break;
            case 'fechas':
              vm.initMultiChartFechas();
              break;
            case 'simulador':
              vm.initMultiChartSimulacion(true);
              break;
          }
        };




        vm.filterFechaInicio = function(date) {
          return true;
        };

        vm.filterFechaTermino = function(date) {
          return true;
        };


        vm.fecha_termino = new Date();
        vm.fecha_inicio  = new Date();
        vm.fecha_semana  = new Date();
        vm.fecha_inicio.setDate(vm.fecha_termino.getDate()-15);

        vm.changeDates = function(){
          if( angular.isDefined(vm.fecha_inicio) &&
            angular.isDefined(vm.fecha_termino)){
            vm.initMultiChartFechas();
          }
        };






        function getVarDatosRiego(dataChart, unix, variable) {
          var r = "no found";
          angular.forEach(dataChart.data.riego, function(riego) {
            if ((riego.unix * 1000) == unix) {
              r = riego[variable];
            }
          });
          return r;
        }

        vm.cambiarTipoComentario = function(){
          if (vm.switchComentario) {
            return ["Un dia",":"];
          }else {
            return ["Periodo","Inicio: "];
          }
        };
        vm.confirmarComentario = function(){
          if (vm.switchComentario) {
            vm.confirmarComentarioFlag();
          }else {
            vm.confirmarComentarioPlot(vm.hf);
          }
        };
        vm.confirmarComentarioFlag = function(){
          var validacion = vm.validarComentario(vm.comentarioTexto,vm.fecha_inicio_comentario,null);
          if (validacion.status) {
            var msjModel = {
              fecha: vm.fecha_inicio_comentario,
              mensaje: vm.comentarioTexto,
              sector_riego_id: vm.cuartel.id
            }
            CuartelRes.mensaje(msjModel).$promise.then(function (success) {
              var nuevoComentariosFecha =[];
              nuevoComentariosFecha.push([ moment(vm.fecha_inicio_comentario).unix()*1000,null, vm.comentarioTexto, success.mensaje.id]);
              vm.comentariosFecha.push([ moment(vm.fecha_inicio_comentario).unix()*1000,null, vm.comentarioTexto, success.mensaje.id]);
              mchart.agregarComentarios(nuevoComentariosFecha,vm);
              vm.menuComentario=!vm.menuComentario;
              vm.limpiarMenuComentario();
              vm.switchComentario=true;
            }, function (err) {
              vm.limpiarMenuComentario();
              console.log("ERROR AL AGREGAR MENSAJE");
            });
          }else {
            vm.errorComentario=validacion.mensaje;
          }
        };




        // startMultiChartEtc();

        vm.startMultiChart = function(dataChart, withConfig) {
          vm.dataChart = dataChart;
          if (angular.isUndefined(withConfig)) {
            withConfig = true;
          }

          var mchart = new MultiChart(dataChart.title + " -- "+ vm.cuartel.nombre);
          if (withConfig) {
            vm.HMChartConfig       = mchart.getConfig();
          }
          //mchart.setStock();

          var datosEtb           = [];
          var datosEt0           = [];
          var datosEtc           = [];
          var datosProg          = [];
          var datosReal          = [];
          var datosTemp          = [];
          var datosGd            = [];
          var datosPrecip        = [];
          var datosEtAcumulada   = [];
          var datosEt0Acumulada  = [];
          var datosEtbAcumulada  = [];
          var datosEtSimulada    = [];
          var datosEtcSimulada   = [];
          var datosRiegoSimulado = [];
          var datosReposicion    = [];
          var datosGramos        = [];
          var datosCalibre       = [];
          var datosEstados       = [];
          var datosRiegoIdeal    = [];

          angular.forEach(dataChart.data.gramaje.dias, function (dato) {
            if (dato.cantidad === null ||dato.cantidad === 0) {
              //datosReposicion.push([riego.unix*1000, null]);
            }else{
              datosGramos.push([dato.unix*1000, parseFloat(dato.cantidad)]);
            }
          });

          angular.forEach(dataChart.data.calibre.dias , function (dato) {
            if (dato.cantidad === null ||dato.cantidad === 0) {
              //datosReposicion.push([riego.unix*1000, null]);
            }else{
              datosCalibre.push([dato.unix*1000, parseFloat(dato.cantidad)]);
            }
          });
          angular.forEach(dataChart.data.riego, function (riego) {

            angular.forEach(vm.cuartel.estados, function(estado) {

              var inicio = moment.unix(estado.inicio).hours(0).minutes(0).unix();
              var final = moment.unix(estado.final).hours(0).minutes(0).unix();
              if (estado.final == 0) {
                final = moment().hours(0).minutes(0).unix();
              }

              var mr = moment.unix(riego.unix);
              var mi = moment.unix(inicio).subtract(1, "day");
              var mf = moment.unix(final).add(1, "day");

              if (mr.isBetween(mi, mf, "days")) {
                if (estado.porcentaje_recuperacion > 0) {
                  datosEstados.push([riego.unix * 1000, estado.porcentaje_recuperacion])
                }
                riego.reposicionIdeal = estado.porcentaje_recuperacion;
                if  (riego.riego_real !== null && riego.riego_real > 0 && riego.reposicionIdeal > 0) {
                  riego.riegoIdeal = _.round((parseFloat(riego.et)/100) * estado.porcentaje_recuperacion, 2);
                  riego.riegoIdeal_h = _.round(riego.riegoIdeal / vm.cuartel.precipitacion_sistema, 2);
                }
              }else{
                datosEstados.push([riego.unix * 1000, null]);
              }
            });

            if (riego.reposicion=== null || riego.reposicion === 0) {
              // datosReposicion.push([riego.unix*1000, null]);
            }else{
              datosReposicion.push([riego.unix*1000, parseFloat(riego.reposicion)]);
            }

            if (riego.etb === null || riego.etb === 0) {
              datosEtb.push([riego.unix*1000, null]);
            }else{
              datosEtb.push([riego.unix*1000, _.round(parseFloat(riego.etb), 2)]);
            }

            if (riego.et0 === null || riego.et0 === 0) {
              datosEt0.push([riego.unix*1000, null]);
            }else{
              datosEt0.push([riego.unix*1000, _.round(parseFloat(riego.et0), 2)]);
            }

            if ( riego.etc === null || riego.etc === 0) {
              datosEtc.push([riego.unix*1000, null]);
            }else{
              datosEtc.push([riego.unix*1000, _.round(parseFloat(riego.etc), 2)]);
            }

            if  (riego.riego_programado === null || riego.riego_programado === 0) {
              datosProg.push([riego.unix*1000, null]);
            }else{
              datosProg.push([riego.unix*1000, parseFloat(riego.riego_programado)]); //XXX no viene
            }

            if  (riego.riegoIdeal ===  undefined || riego.riegoIdeal === 0) {
              datosRiegoIdeal.push([riego.unix*1000, null]);
            }else{
              datosRiegoIdeal.push([riego.unix*1000, parseFloat(riego.riegoIdeal)]);
            }

            if  (riego.riego_real === null || riego.riego_real === 0) {
              datosReal.push([riego.unix*1000, null]);
            }else{
              datosReal.push([riego.unix*1000, parseFloat(riego.riego_real)]);
            }

            if  (riego.temperatura === null || riego.temperatura === 0) {
              datosTemp.push([riego.unix*1000, null]);
            }else{
              datosTemp.push([riego.unix*1000, parseFloat(riego.temperatura)]);
            }

            if  (riego.grados_dia=== null || riego.grados_dia=== 0) {
              datosGd.push([riego.unix*1000, 0]);
            }else{
              datosGd.push([riego.unix*1000, parseFloat(riego.grados_dia)]);
            }

            if  (riego.precipitacion === null || riego.precipitacion === 0) {
              datosPrecip.push([riego.unix*1000, null]);
            }else{
              datosPrecip.push([riego.unix*1000, _.round(parseFloat(riego.precipitacion), 2)]);
            }

            if  (riego.et0_acum === null || riego.et0_acum === 0) {
              datosEt0Acumulada.push([riego.unix*1000, null]);
            }else{
              datosEt0Acumulada.push([riego.unix*1000, parseFloat(riego.et0_acum)]);
            }

            if  (riego.et === null || riego.et === 0) {
              datosEtAcumulada.push([riego.unix*1000, null]);
            }else{
              datosEtAcumulada.push([riego.unix*1000, parseFloat(riego.et)]);
            }

            if  (riego.etb_acum === null || riego.etb_acum === 0) {
              datosEtbAcumulada.push([riego.unix*1000, null]);
            }else{
              datosEtbAcumulada.push([riego.unix*1000, parseFloat(riego.etb_acum)]);
            }

            if  (riego.etc_acum_simulada === null || riego.etc_acum_simulada === 0) {
              datosEtcSimulada.push([riego.unix*1000, null]);
            }else{
              datosEtcSimulada.push([riego.unix*1000, _.round(parseFloat(riego.etc_acum_simulada), 2)]);
            }

            if  (riego.et_acum_simulada === null || riego.et_acum_simulada === 0) {
              datosEtSimulada.push([riego.unix*1000, null]);
            }else{
              datosEtSimulada.push([riego.unix*1000, _.round(parseFloat(riego.et_acum_simulada), 2)]);
            }

            if  (riego.riego_simulado === null || riego.riego_simulado=== 0) {
              datosRiegoSimulado.push([riego.unix*1000, null]);
            }else{
              datosRiegoSimulado.push([riego.unix*1000, parseFloat(riego.riego_simulado)]);
            }

          });

          if(vm.lapsoTiempo.label === "simulador"){

            mchart.agregarSerie({
              color     : Config.colors.etAcumulado.background,
              name      : 'ET0 Acumulada',
              yAxis     : 2,
              lineWidth : 1,
              suffix    : ' mm',
              data      : datosEt0Acumulada
            });

            mchart.agregarSerie({
              color     : Config.colors.etAcumulado.background,
              name      : 'ETB Acumulada',
              yAxis     : 2,
              lineWidth : 1,
              suffix    : ' mm',
              data      : datosEtbAcumulada
            });

            mchart.agregarSerie({
              color     : Config.colors.etSimulado.background,
              name      : 'ET Acumulada (simulado)',
              yAxis     : 2,
              lineWidth : 1,
              suffix    : ' mm',
              data      : datosEtSimulada,
            });


            mchart.agregarSerie({
              color     : Config.colors.riegoSimulado.background,
              name      : 'Riego simulado',
              yAxis     : 2,
              type      : 'column',
              lineWidth : 2,
              width          : 5,
              suffix    : ' mm',
              data      : datosRiegoSimulado,
              //visible   : false,
              pointFormatter : function() {
                var icon = '<i class="fa fa-circle" aria-hidden="true"></i>';
                return '<tr><td><span style="color:' +Config.colors.riegoSimulado.background +
                  '">'+icon+'</span> Riego Simulado: </td><td style="white-space:nowrap; font-weight: bold">'+
                  getVarDatosRiego(vm.dataChart, this.x, "riego_simulado")+"mm - "+
                  getVarDatosRiego(vm.dataChart, this.x, "riego_simulado_h")+' Hrs</td></tr>';
              }
            });

          }else{

            mchart.agregarSerie({
              color     : Config.colors.gramos.background,
              name      : 'Gramos',
              yAxis     : 16,
              lineWidth : 2,
              suffix    : ' gr',
              data      : datosGramos,
            });
            mchart.agregarSerie({
              color     : Config.colors.calibre.background,
              name      : 'Calibre',
              yAxis     : 0,
              lineWidth : 2,
              suffix    : ' mm',
              data      : datosCalibre
            });

            //if(Config.vinedo['estacionMet']){ //jshint ignore:line
            mchart.agregarSerie({
              color     : Config.colors.et0.background,
              name      : 'Et0',
              yAxis     : 13,
              lineWidth : 1,
              suffix    : ' mm',
              type      : 'area',
              data      : datosEt0,
              //visible   : Config.vinedo['estacionMet'],
              visible   : false
            });
            //}else{
            mchart.agregarSerie({
              color     : Config.colors.etb.background,
              name      : 'Etb',
              yAxis     : 13,
              lineWidth : 1,
              suffix    : ' mm',
              type      : 'area',
              data      : datosEtb,
              //visible   : Config.vinedo['conBandeja'],
              visible   : false
            });
            //}



            mchart.agregarSerie({
              color        : Config.colors.riegoIdeal.background,
              name         : 'Reposicion Ideal',
              type         : 'spline',
              markerSymbol : 'circle',
              radius       : 2,
              yAxis        : 12,
              lineWidth    : 2,
              preffix      : '',
              suffix       : ' %',
              visible      : false,
              data:datosEstados
            });


            mchart.agregarSerie({
              color     : Config.colors.temperatura.background,
              name      : 'Temperatura',
              yAxis     : 0,
              lineWidth : 2,
              suffix    : ' °C',
              data      : datosTemp,
              visible   : false
            });

            mchart.agregarSerie({
              color     : Config.colors.temperatura.background,
              name      : 'Grados Dia',
              yAxis     : 0,
              lineWidth : 2,
              suffix    : ' gd',
              data      : datosGd,
              visible   : false
            });


            mchart.agregarSerie({ //XXX no viene
              color   : Config.colors.riegoProgramado.background,
              name    : 'Riego Programado',
              yAxis   : 2,
              type    : 'column',
              suffix  : ' mm',
              width   : 5,
              data    : datosProg,
              visible : false
            });

            mchart.agregarSerie({
              color     : Config.colors.etAcumulado.background,
              name      : 'Et Acumulada',
              yAxis     : 2,
              lineWidth : 2,
              suffix    : ' mm',
              data      : datosEtAcumulada,
              visible   : false
            });

            mchart.agregarSerie({
              color     : Config.colors.precipitacion.background,
              name      : 'Precipitacion',
              yAxis     : 2,
              type      : 'column',
              lineWidth : 2,
              width          : 5,
              suffix    : ' mm',
              data      : datosPrecip
            });





            //Sensores
            if(dataChart.data.sectores && dataChart.data.sectores.length > 0 && dataChart.data.sectores[0].length > 0){

              angular.forEach(dataChart.data.sectores, function (sector) {
                var dataSumSensores = [];
                var dataSensor      = {};
                var correlacion     = {};
                var l = sector[0].length - 1;
                _.each(sector, function(sensor, index){
                  if(index == 0){
                    _.each(sensor, function(h, i){
                      if(i >0){
                        dataSensor[h] = [];
                        correlacion[i] = h;
                      }
                    });
                  }else{
                    var unix = sensor[0];
                    var sum = 0;
                    _.each(sensor, function(d, i){
                      if(i >0){
                        dataSensor[correlacion[i]].push([unix*1000, _.round(d, 1)]);
                        sum += _.round(d, 1);
                      }
                    });
                    /*if(!sector.sumar){
                    sum = sum / l;
                  }*/
                  dataSumSensores.push([unix*1000, _.round(sum, 2)]);

                }
              });

              function sortFunction(a, b) {
                if (a[0] === b[0]) {
                  return 0;
                }
                else {
                  return (a[0] < b[0]) ? -1 : 1;
                }
              }
              dataSumSensores.sort(sortFunction);



              //Agrega Scholander a todos los graficos
              var datosScholander = [];
              angular.forEach(dataChart.data.bomba.dias, function (bomba) {
                if (parseFloat(bomba.cantidad) === 0) {
                  //datosScholander.push([bomba.unix*1000, null]);
                }else{
                  datosScholander.push([bomba.unix*1000, parseFloat(bomba.cantidad)]);
                }
              });




              angular.forEach(dataSensor, function (sensor, index) {
                if (!Config.vinedo['FDR'] && false) {
                  mchart.agregarSerie({
                    name         : 'Sensor ' + parseInt(index) + "cm",
                    yAxis        : 3,
                    radius       : 3,
                    type         : 'spline',
                    suffix       : ' %',
                    markerSymbol : 'triangle',
                    data         : sensor,
                    required     : true,
                    visibleAxis  : true
                  });
                }
                else {
                  mchart.agregarSerie({
                    name        : 'Sensor ' + parseInt(index) + "cm",
                    yAxis       : 3,
                    type        : 'spline',
                    lineWidth   : 2,
                    suffix      : ' %',
                    data        : sensor,
                    required    : true,
                    visibleAxis : true,
                    dataGrouping:{
                      units: [[
                        'day',
                        [1]
                      ]]
                    }
                  });
                }
              });






              if (ur > 0){
                mchart.addPlotLineY({
                  color   : Config.colors["ur"].background,
                  title   : "UR "+ur+"%",
                  yAxis   : 3,
                  value   : ur,
                  tag     : "sensor",
                  align: "right"
                });
              }

              if (cc > 0) {
                mchart.addPlotBandY({
                  color   : Config.colors["saturacion"].background,
                  borde   : Config.colors["saturacion"].border,
                  title   : "Sat > " + cc + "%",
                  yAxis   : 3,
                  to      : cc + 20,
                  opacity : 30,
                  from    : cc,
                  tag     : "sensor",
                  align: "right"
                });

                mchart.addPlotBandY({
                  color   : Config.colors["cc"].background,
                  borde   : Config.colors["cc"].border,
                  title   : "CC " + cc + "%",
                  yAxis   : 3,
                  to      : cc,
                  opacity : 30,
                  from    : pmp,
                  tag     : "sensor",
                  align: "right"
                });
              }

              if (pmp > 0) {
                mchart.addPlotBandY({
                  color   : Config.colors["pmp"].background,
                  borde   : Config.colors["pmp"].border,
                  title   : "pmp " + pmp + "%",
                  yAxis   : 3,
                  to      : pmp,
                  opacity : 30,
                  from    : pmp - 10,
                  tag     : "sensor",
                  align: "right"
                });
              }
              mchart.agregarSerie({
                color       : Config.colors.etAcumulado.background,
                name        : 'Franjas Sensores',
                yAxis       : 3,
                required    : true,
                visibleAxis : true,
                events      : {
                  legendItemClick : function (e) {
                    mchart.toggleBands("sensor");
                  }
                }
              });

            });
          }// END if sensores

          } //END ELSE

          mchart.agregarSerie({
            color          : Config.colors.riegoIdeal.background,
            name           : 'Riego Ideal',
            yAxis          : 2,
            type           : 'column',
            data           : datosRiegoIdeal,
            required       : true,
            width          : 5,
            visible        : true,
            pointFormatter : function() {
              var icon = '<i class="fa fa-square" aria-hidden="true"></i>';
              return '<tr><td><span style="color:' +Config.colors.riegoIdeal.background +
                '">'+icon+'</span> Riego Ideal: </td><td style="white-space:nowrap; font-weight: bold">'+
                getVarDatosRiego(vm.dataChart, this.x, "riegoIdeal")+'mm - '+
                getVarDatosRiego(vm.dataChart, this.x, "riegoIdeal_h")+' Hrs</td></tr>';
            }
          });

          mchart.agregarSerie({
            color          : Config.colors.riegoReal.background,
            name           : 'Riego Real',
            yAxis          : 2,
            type           : 'column',
            data           : datosReal,
            required       : true,
            width          : 5,
            pointFormatter : function() {
              var icon = '<i class="fa fa-square" aria-hidden="true"></i>';
              return '<tr><td><span style="color:' +Config.colors.riegoReal.background +
                '">'+icon+'</span> Riego Real: </td><td style="white-space:nowrap; font-weight: bold">'+
                getVarDatosRiego(vm.dataChart, this.x, "riego_real")+'mm - '+
                getVarDatosRiego(vm.dataChart, this.x, "riego_real_h")+' Hrs</td></tr>';
            }
          });

          //porcentaje de Reposicion a todos los graficos
          mchart.agregarSerie({
            color        : Config.colors.riegoReal.background,
            name         : 'Reposicion',
            type         : 'spline',
            markerSymbol : 'circle',
            radius       : 2,
            yAxis        : 12,
            lineWidth    : 2,
            preffix      : '',
            suffix       : ' %',
            // legend       : false,
            visible      : false,
            data: datosReposicion
          });

          var datosScholander = [];
          angular.forEach(dataChart.data.bomba.dias, function (bomba) {
            if (parseFloat(bomba.cantidad) !== 0) {
              datosScholander.push([bomba.unix*1000, parseFloat(bomba.cantidad)]);
            }
          });

          mchart.agregarSerie({
            color        : Config.colors.scholander.background,
            name         : 'Bomba Scholander',
            markerSymbol : 'circle',
            type         : "spline",
            radius       : 3,
            yAxis        : 1,
            preffix      : '-',
            suffix       : ' bar',
            visibleAxis  : true,
            withLabels: true,
            limite       : {
              name  : "Limite Scholander :" + dataChart.data.bomba.limit+" bar",
              cant  : dataChart.data.bomba.limit,
              color : Config.colors.scholander.background,
              max   : 20
            },
            data: datosScholander
          });

          var datosPorometro= [];
          angular.forEach(dataChart.data.porometro.dias, function (diaPorometro) {
            if (parseFloat(diaPorometro.cantidad) !== 0) {
              datosPorometro.push([diaPorometro.unix*1000, parseFloat(diaPorometro.cantidad)]);
            }
          });

          mchart.agregarSerie({
            color       : Config.colors.porometro.background,
            name        : 'Porometro',
            markerSymbol: 'circle',
            type        : "spline",
            radius      : 3,
            yAxis       : 15,
            suffix      : ' mmol/m2s',
            visibleAxis : true,
            data        : datosPorometro
          });


          if(dataChart.conEstados){
            var i = 1;
            var arrayEstados = [];
            //var estados = [];
            if(dataChart.estados == undefined){
              arrayEstados = angular.copy(vm.cuartel.estados);
            }else{
              arrayEstados = dataChart.estados;
            }
            angular.forEach(arrayEstados, function(estado, key) {
              estado.inicio = moment.unix(estado.inicio).hours(0).minutes(0).unix();
              if (estado.final == 0) {
                estado.final = moment().hours(23).minutes(59).unix();
              }else{
                estado.final= moment.unix(estado.final).hours(23).minutes(59).unix();
              }


              /*
              estados.push({
                color  : Config.colors["etapa"+i].background,
                borde  : Config.colors["etapa"+i].border,
                titulo : '<b>'+estado.nombre+'</b>', //<br />'+inicio+"<br/>"+termino ,
                desde  : estado.inicio * 1000,
                hasta  : estado.final* 1000,
              });
              */
              var p = "";
              if (estado.porcentaje_recuperacion > 0) {
                p = ' - ' + estado.porcentaje_recuperacion + '%';
              }

              var titulo  = '<b>' + estado.nombre + p + '</b>';

              if (estado.grados_dia_inicio > 0 && estado.grados_dia_fin>0) {
                titulo  += '<br/> <span class="grey">('+estado.grados_dia_inicio+' - '+estado.grados_dia_fin+') </span>';
              }

              titulo  += '<br/> <i class="md-blue">'+ moment.unix(estado.inicio).format("DD MMM") + ' - ' + moment.unix(estado.final).format("DD MMM") + '</i>';

              mchart.addPlotBand({
                //color  : Config.colors["etapa"+i].background,
                //borde  : Config.colors["etapa"+i].border,
                color: Config.colors.grey.background,
                border: Config.colors.grey.border,
                titulo : titulo,
                align: "center",
                par    : key%2,
                desde  : estado.inicio * 1000,
                hasta  : estado.final* 1000,
                tag: "estado"
              });
              i = i == 4? 1 : i+1;
            });

            mchart.agregarSerie({
              color       : Config.colors.etAcumulado.background,
              name        : 'Estados fenológicos',
              required    : true,
              visibleAxis : true,
              yAxis       : 3, //HACK
              events      : {
                legendItemClick : function (e) {
                  mchart.toggleBands("estado");
                }
              }
            });
            //envia el rango de fechas seleccionado, corroborar los parametros inicio y fin, que se envien a la funcion
            //mchart.addEstados(estados, new Date(this.temporadaSelected.inicio)*1,new Date(this.temporadaSelected.fin)*1);
            mchart.addEventosRedraw(new Date(this.temporadaSelected.inicio)*1,new Date(this.temporadaSelected.fin)*1);
          }

          $timeout(function() {
            var c = vm.HMChartConfig.getChartObj();
            c.render();
          },1000);
          return mchart;
        };// END startMultiChart








        vm.limpiarMenuComentario = function(){
          vm.limpiarComentario();
          vm.switchComentario=true;
          vm.errorComentario="";
          vm.fecha_termino_comentario  = moment(new Date()).toDate();
          vm.fecha_inicio_comentario = moment(new Date()).subtract(1,'days').toDate();
        };



        vm.limpiarComentario = function(){
          vm.comentarioTexto="";
        };



        vm.confirmarComentarioPlot = function(mchart){
          var validacion = vm.validarComentario(vm.comentarioTexto,vm.fecha_inicio_comentario,vm.fecha_termino_comentario);
          if (validacion.status) {
            var msjModel ={
              fecha: vm.fecha_inicio_comentario,
              fecha_cierre: vm.fecha_termino_comentario,
              mensaje: vm.comentarioTexto,
              sector_riego_id: vm.cuartel.id
            }
            CuartelRes.mensaje(msjModel).$promise.then(function (success){
              mchart.agregarComentarioRango([[moment(vm.fecha_inicio_comentario).unix()*1000,
                moment(vm.fecha_termino_comentario).unix()*1000,vm.comentarioTexto,success.mensaje.id]],vm);
              vm.menuComentario=!vm.menuComentario;
              vm.limpiarMenuComentario();
            }, function(err){
              vm.limpiarMenuComentario();
              console.log("ERROR AL AGREGAR MENSAJE");
            });
          }else{
            vm.errorComentario = validacion.mensaje;
          }
        };

        vm.validarComentario = function(texto,fecha1,fecha2){
          var validacion={
            status: true,
            mensaje: ""
          };
          if (texto=="") {
            validacion.status=false;
            validacion.mensaje="No ha escrito nungún comentario.";
          }else {
            if (fecha2===null) {//es Flag no importa la fecha
              validacion.status=true;
              validacion.mensaje="";
            }else if (moment(fecha1).isAfter(fecha2,'day')) {//es plot, valida la fecha final
              validacion.status=false;
              validacion.mensaje="La fecha de inicio no puede ser posterior a la fecha de término.";
            }
          }
          return validacion;
        };



        vm.editarComentario = function(){ //Muestra el menu de editar comentario y cargo los campos con el mensaje seleccionado
          vm.menuEditarComentario=!vm.menuEditarComentario;
          vm.menuComentario=false;
          vm.mostrarTooltipPlotband=false;
          if (vm.mensajeSeleccionado[1]===null) {
            vm.editarComentarioIsPlot=false;
            vm.editarComentarioInicio=moment(vm.mensajeSeleccionado[0]).toDate();
            vm.editarComentarioTexto=vm.mensajeSeleccionado[2];
          }else{
            vm.editarComentarioIsPlot=true;
            vm.editarComentarioInicio=moment(vm.mensajeSeleccionado[0]).toDate();
            vm.editarComentarioFin=moment(vm.mensajeSeleccionado[1]).toDate();
            vm.editarComentarioTexto=vm.mensajeSeleccionado[2];
          }
        }


        vm.limpiarErrorEditar=function(){
          vm.errorEditarComentario="";
        }



        vm.editarComentarioConfirmar = function(){
          var fecha_cierre = "";
          if (vm.mensajeSeleccionado[1]===null) {
            fecha_cierre = null;
          }else {
            fecha_cierre = vm.editarComentarioFin;
          }
          var validacion=vm.validarComentario(vm.editarComentarioTexto,vm.editarComentarioInicio,fecha_cierre);
          if (validacion.status) {
            var msjModel ={
              fecha           : vm.editarComentarioInicio,
              fecha_cierre    : fecha_cierre,
              mensaje         : vm.editarComentarioTexto,
              sector_riego_id : vm.cuartel.id,
              id              : vm.mensajeSeleccionado[3]
            }
            CuartelRes.mensaje(msjModel).$promise.then(function(success){
              if (msjModel.fecha_cierre===null) {
                angular.forEach(vm.comentariosFecha, function(comentario) {
                  if (comentario[3]==msjModel.id) {
                    comentario[0] =moment(msjModel.fecha).unix()*1000;
                    comentario[2]=msjModel.mensaje;
                  }
                });
              }else {
                angular.forEach(vm.comentariosFechaPlot, function(comentario) {
                  if (comentario[3]==msjModel.id) {
                    comentario[0] =moment(msjModel.fecha).unix()*1000;
                    comentario[1] =moment(msjModel.fecha_cierre).unix()*1000;
                    comentario[2]=msjModel.mensaje;
                  }
                });
              }
              angular.forEach(vm.hf.HcConfig.series, function(series) {
                if (series.type=="flags") {
                  angular.forEach(series.data, function(comentarioFlag) {
                    if (comentarioFlag.id==msjModel.id) {
                      comentarioFlag.text=msjModel.mensaje;
                      comentarioFlag.x=moment(msjModel.fecha).unix()*1000;
                    }
                  });
                }
              });

              angular.forEach(vm.hf.comentariosRect, function(comentarioRect) {
                if (comentarioRect.id == msjModel.id) {
                  comentarioRect.from       = moment(msjModel.fecha).unix()*1000;
                  comentarioRect.to         = moment(msjModel.fecha_cierre).unix()*1000;
                  comentarioRect.label.text = msjModel.mensaje.substring(0, 7) + "...";
                }
              });

              vm.menuEditarComentario=false;
              vm.limpiarErrorEditar();
              console.log("Modificacion confirmada");
            },function(err){
              console.log("Error al modificar");
            });
          }else{
            vm.errorEditarComentario=validacion.mensaje;
          }
        }
        vm.eliminarComentario = function(){
          if (confirm("¿Eliminar Comentario?")) {
            CuartelRes.deleteMensaje({
              mensaje_id : vm.mensajeSeleccionado[3],
              sector_riego_id: vm.cuartel.id
            },function(){
              vm.hf.limpiarComentarios(); //Elimina los mensajes del grafico
              vm.mostrarTooltipPlotband=false;
              switch(vm.lapsoTiempo.label){ //inserta los mensajes dependiendo la vista actual
                case 'mes':
                  var inicio = moment(vm.fecha_semana).subtract(1, "month").toDate();
                  vm.insertarMensajes(vm.hf,inicio,vm.fecha_semana);
                  break;
                case 'temporada':
                  vm.insertarMensajes(vm.hf,new Date(vm.temporadaSelected.inicio),new Date(vm.temporadaSelected.fin));
                  break;
                case 'fechas':
                  vm.insertarMensajes(vm.hf,vm.fecha_inicio,vm.fecha_termino);
                  break;
              }
            });
            vm.menuComentario = false;
            vm.menuEditarComentario = false;
            vm.limpiarErrorEditar();
          }else{
            vm.menuEditarComentario=false;
            vm.limpiarErrorEditar();
          }
        }
        vm.insertarMensajes = function(mchart,fecha_inicio,fecha_fin){
          return CuartelRes.getMensaje({
            sector_riego_id : vm.cuartel.id,
            fecha_inicio    : fecha_inicio,
            fecha_fin       : fecha_fin,
          }, function(data){
            vm.comentariosFecha = [];
            vm.comentariosFechaPlot = [];
            vm.comentariosFechaRect = [];
            angular.forEach(data.data.mensajes, function(dia){
              if(angular.isDefined(dia.mensajes)){
                angular.forEach(dia.mensajes, function(mensaje){
                  if(mensaje.msj.replace(" ", "") === "") return;
                  if(mensaje.fecha_cierre===null){
                    vm.comentariosFecha.push([mensaje.fecha * 1000,null ,mensaje.msj , mensaje.id]);
                  }else{
                    vm.comentariosFechaPlot.push([mensaje.fecha * 1000 ,mensaje.fecha_cierre * 1000 ,mensaje.msj, mensaje.id]);
                  }
                });
              }
            });
            mchart.agregarComentarios(vm.comentariosFecha,vm);
            mchart.agregarComentarioRango(vm.comentariosFechaPlot, vm);
            $rootScope.$broadcast('highcharts.redraw');
          });
        };

        vm.initMultiChartMes = function(){
          vm.loadingFechas = true;
          var fecha_inicio = moment(vm.fecha_semana).subtract(1, "month").toDate();
          var fecha_fin    = vm.fecha_semana;
          CuartelRes.getTemporada({
            sector_riego_id : vm.cuartel.id,
            fecha_inicio    : fecha_inicio,
            fecha_fin       : fecha_fin
          }, function(data){
            vm.cuartel.precipitacion = data.data.precipitacion;
            vm.cuartel.precipitaciones = data.data.precipitaciones;

            //saturacion = data.data.variables.saturacion;
            ur = data.data.variables.saturacion;
            cc = data.data.variables.cc;
            pmp = data.data.variables.ppm;// pmp, backend typo
            if(data.data.variables.pmp !== undefined){
              pmp = data.data.variables.pmp;
            }
            vm.hf = vm.startMultiChart({
              data       : data.data,
              title      : "Datos del ultimo mes para sector " + vm.cuartel.nombre,
              subtitle   : "Desde " + moment(fecha_inicio).format("D [de] MMM") + " hasta " + moment(fecha_fin).format("D [de] MMM"),
              conEstados : false
            });
            vm.table         = data.data.tabla;
            vm.loadingFechas = false;
            vm.fechas_table  = data.data.tabla;
            vm.insertarMensajes(vm.hf, fecha_inicio, fecha_fin);
          });
        };

        vm.initMultiChartTemporada = function(){
          vm.loadingFechas = true;
          CuartelRes.getTemporada({
            sector_riego_id : vm.cuartel.id,
            fecha_inicio    : new Date(vm.temporadaSelected.inicio),
            fecha_fin       : new Date(vm.temporadaSelected.fin),
            periodo         : vm.temporadaSelected.periodo
          }, function(data){
            vm.cuartel.precipitacion = data.data.precipitacion;
            vm.cuartel.precipitaciones = data.data.precipitaciones;

            //saturacion = data.data.variables.saturacion;
            ur = data.data.variables.saturacion;
            cc = data.data.variables.cc;
            pmp = data.data.variables.ppm;// pmp, backend typo
            if(data.data.variables.pmp !== undefined){
              pmp = data.data.variables.pmp;
            }

            vm.hf = vm.startMultiChart({
              data       : data.data,
              title      : "Datos de Temporada "+vm.temporadaSelected.periodo,
              conEstados : true
            });
            vm.table = data.data.tabla;
            vm.fechas_table = data.data.tabla;
            vm.insertarMensajes(vm.hf, vm.temporadaSelected.inicio, vm.temporadaSelected.fin)
            vm.loadingFechas = false;
            vm.loadingTemporada = false;
          });
        };
        vm.initMultiChartTemporadaComparada = function(inicio,fin, title){
          vm.loadingTemporadaComparada = true;

          var fecha_inicio = new Date(vm.temporadaComparada.inicio);
          var fecha_fin    = new Date(vm.temporadaComparada.fin);

          if (inicio) {
            fecha_inicio = inicio;
          }
          if (fin) {
            fecha_fin = fin;
          }

          CuartelRes.getTemporada({
            sector_riego_id : vm.cuartel.id,
            fecha_inicio    : fecha_inicio,
            fecha_fin       : fecha_fin,
            periodo         : vm.temporadaComparada.periodo
          }, function(data){
            vm.hf2 = vm.startMultiChart({
              data       : data.data,
              title      : title || "Datos de Temporada "+vm.temporadaComparada.periodo,
              conEstados : true
            }, false);
            vm.tableCompared = data.data.tabla;
            vm.HMChartConfigComparada = vm.hf2.getConfig();
            vm.loadingTemporadaComparada = false;
            vm.insertarMensajes(vm.hf2, vm.temporadaComparada.inicio, vm.temporadaComparada.fin);
            vm.loadingComparison = false;
          });
        };

        vm.initMultiChartSimulacion = function(inicial){
          inicial          = inicial || false;
          vm.riegoNormalMM = Math.round(vm.riegoNormal * vm.cuartel.precipitacion_sistema * 100)/100;
          vm.loadingFechas = true;
          var year         = moment(new Date()).year();
          var inicio       = new Date((year-1)+"/10/1");
          var fin          = new Date(year+"/05/15");
          var estadosFormateados = formatearEstados(vm.estados);
          popoverEstadosDirty = false;

          var params = {
            sector_riego_id : vm.cuartel.id,
            fecha_inicio    : inicio,   //vm.cuartel.temporada.inicio * 1000),
            fecha_fin       : fin,   //vm.cuartel.temporada.fin * 1000),
            horas           : vm.riegoNormal,
            porcentaje      : vm.reposicion,
            exedente        : vm.exedente
          }
          params = angular.extend(params, estadosFormateados);

          CuartelRes.getSimulacion(params, function(data){
            vm.simuladorData = data.data.simulacion;
            if (inicial){
              vm.riegoNormal = data.data.simulacion.simulado.horas_riego;
              vm.reposicion  = data.data.simulacion.real.reposicion;
              vm.riegoNormalMM = Math.round(vm.riegoNormal * vm.cuartel.precipitacion_sistema * 100)/100;
            }
            //reformat estados por falta de estandarizacino
            angular.forEach(data.data.estados, function(estado){
              estado.inicio = estado.fecha_inicio_unix;
              estado.final  = estado.fecha_fin_unix;
            });
            vm.hf = vm.startMultiChart({
              data       : data.data,
              title      : "Simulación",
              conEstados : true,
              estados: data.data.estados
            });
            vm.loadingFechas = false;
            vm.fechas_table  = data.data.tabla;
          });
        };
        vm.initMultiChartFechas = function(){
          vm.loadingFechas = true;
          CuartelRes.getTemporada({
            sector_riego_id: vm.cuartel.id,
            fecha_inicio: vm.fecha_inicio,
            fecha_fin: vm.fecha_termino
          }, function(data){

            //saturacion = data.data.variables.saturacion;
            ur = data.data.variables.saturacion;
            cc = data.data.variables.cc;
            pmp = data.data.variables.ppm;// pmp, backend typo
            if(data.data.variables.pmp !== undefined){
              pmp = data.data.variables.pmp;
            }

            vm.hf = vm.startMultiChart({
              data: data.data,
              title: "Dato desde "+ moment(vm.fecha_inicio).format("D [de] MMM") +" hasta "+  moment(vm.fecha_termino).format("D [de] MMM"),
              conEstados: false
            });
            vm.loadingFechas = false;
            vm.table = data.data.tabla;
            vm.fechas_table = data.data.tabla;
            vm.insertarMensajes(vm.hf, vm.fecha_inicio, vm.fecha_termino);
          });
        };


        vm.changeComparisonType= function(type) {
          vm.comparisonType = type;
          vm.loadingComparison = true;
          if (type == "temporada") {
            vm.initMultiChartTemporadaComparada();
          }
          if (type == "fecha") {
            vm.initMultiChartTemporadaComparada(
              vm.temporadaComparada.inicio,
              moment().subtract(1, "year").toDate(),
              "Datos de Temporada "+vm.temporadaComparada.periodo+", a la fecha"
            );
          }
        }





        //----------------------------------
        //--- Estados ----------------------
        //----------------------------------

        vm.hidePopoverEstado = function() {
          vm.hideBackdrop();
          vm.terminarEdicionEstados();
        };


        vm.estadoValido = function(estado) {
          return true;
          var valido = true;
          var mi = moment(estado.dateInicio);
          var mf = moment(estado.dateTermino);
          if (estado.nombre == "") {
            valido = false;
            //console.error("nombre vacio");
          }
          if (estado.dateInicio == "" || estado.dateInicio == "" || !mi.isValid()) {
            valido = false;
            //console.error("inicio invalido");
          }
          if (mf.isValid()) {
            if (mf.isBefore(mi)) {
              valido = false;
              //console.error("fin invalido");
            }
          }
          return valido;
        }

        vm.guardarEstadoNuevo = function(estadoNuevo) {
          popoverEstadosDirty = true;
          estadoNuevo.editando = false;
          vm.estados.push(angular.copy(estadoNuevo));
          vm.estadoNuevo = null;
        }

        vm.guardarEstado = function(estado){
          estado.editando = false;
          popoverEstadosDirty = true;
        }


        vm.cancelarEdicionEstado = function(estado) {
          angular.forEach(vm.cuartel.estados, function(estadoC) {
            if(estadoC.id == estado.id){
              $timeout(function() {
                estado.id             = estadoC.id;
                estado.inicio         = estadoC.inicio;
                estado.nombre         = estadoC.nombre;
                estado.final          = estadoC.final;
                estado.porcentaje_recuperacion = estadoC.porcentaje_recuperacion;
                estado.dateInicio     = moment.unix(estado.inicio).toDate();
                estado.dateTermino    = moment.unix(estado.final).toDate();
              });
            }
          });
          estado.editando = false;
        }

        vm.cancelarEdicionEstadoNuevo = function() {
          vm.estadoNuevo = null;
        }

        vm.showBackdrop = function(fn) {
          if (fn !== undefined && fn !== null) {
            hideBackdropCallback = fn;
          }
          vm.showedBackdrop = true;
        }


        vm.verificarPeriodo = function(estado, temporada) {
          var mi = moment(temporada.inicio, "YYYY-MM-DD");
          var mf = moment(temporada.fin, "YYYY-MM-DD");
          var me = moment(estado.dateInicio);
          if (me.isBetween(mi, mf, null, '[]')) {
            return true;
          }
          return false;
        }


        vm.agregarEstado = function() {
          vm.estadoNuevo = {
            dateInicio  : new Date(),
            dateTermino : new Date(),
            nombre      : "",
            editando    : true
          }
        }

        vm.showdialogDeleteEstadoWindow = function(cuartelDia, estado, ev) {
          var confirm = $mdDialog.confirm()
            .title('¿Realmente quieres quitar el estado <<'+estado.nombre+'>> ??')
            .textContent('La eliminacion solo sera para este caso')
            .ariaLabel('Borrar Estado')
            .targetEvent(ev)
            .ok('Borrar')
            .cancel('Cancelar');

          var p = $mdDialog.show(confirm);
          p.then(function() {
            popoverEstadosDirty = true;
            angular.forEach(vm.estados, function(estadoOriginal, index) {
              if (estadoOriginal.id == estado.id) {
                vm.estados.splice(index, 1);
              }
            });
          }, function() {
            console.error("Problemas al borrar estado");
          });
          return p;
        };


        vm.hideBackdrop = function() {
          if (hideBackdropCallback !== null) {
            hideBackdropCallback();
            hideBackdropCallback = null;
          }
          vm.showedBackdrop = false;
        }

        vm.terminarEdicionEstados = function(){
          vm.showedWindowEstado = false;
          if(popoverEstadosDirty){
            vm.initMultiChartSimulacion(false);
          }
        }

        function formatearEstados(estados) {
          var estadosFormateados = {};
          angular.forEach(estados, function(estado, i){
            if(vm.verificarPeriodo(estado, vm.temporadaSelectedWindow)){
              estadosFormateados["estados["+i+"][nombre]"] = estado.nombre;
              estadosFormateados["estados["+i+"][fecha_inicio]"] = estado.dateInicio;
              estadosFormateados["estados["+i+"][fecha_fin]"] = estado.dateTermino;
              estadosFormateados["estados["+i+"][porcentaje_recuperacion]"] = estado.porcentaje_recuperacion;
            }
          });
          return estadosFormateados;
        }

        /**
         * TODO
         * - verificar si hubo edicion de lista de estados
         * - enviar estados en peticion
         */
        vm.showPopoverEstado = function(event) {

          vm.showBackdrop(function() {
            vm.terminarEdicionEstados();
          });

          vm.showedWindowEstado  = true;

          var kh               = 35;
          var kw               = 19; //32;
          var alturaWindow     = 270;
          var medioAnchoWindow = 300;
          var heightContent    = $("#content").height();
          var widthOffset      = 0;
          var target           = null;

          if (event.target.localName === "span") {
            target = event.target.offsetParent;
          }else{
            target = event.target;
          }

          if (vm.visibleSidebarDetails) {
            widthOffset = medioAnchoWindow;
            $(".estado-cuartel-window").addClass("center-arrow");
          }else{
            $(".estado-cuartel-window").removeClass("center-arrow");
          }

          if ((target.getBoundingClientRect().top-kh) > (heightContent/2)) {
            $(".estado-cuartel-window").removeClass("top-arrow").addClass("bottom-arrow")
              .css({
                left : target.getBoundingClientRect().left - kw - widthOffset,
                top  : target.getBoundingClientRect().top - kh - alturaWindow + $("#content").scrollTop()
              });
          }else{
            $(".estado-cuartel-window").removeClass("bottom-arrow").addClass("top-arrow")
              .css({
                left : target.getBoundingClientRect().left - kw - widthOffset,
                top  : target.getBoundingClientRect().top - kh + $("#content").scrollTop()
              });
          }

        };


        $( "#content" ).scroll(function() {
          vm.scroll = $("#content")[0].scrollTop;
        });

      }]);

})();
